<template>
  <div
    class="ezcred-loading-container"
    v-if="loading">

    <wxc-overlay
      :show="true"
      :hasAnimation="false"
      :opacity="0"
      ></wxc-overlay>

    <div class="progress-container">
      <div class="progress">
        <v-progress-circular
          class="horizontal_center"
          indeterminate
          color="white"
          size="48"
          ></v-progress-circular>
        <weex-text
          class="margin-top-20 text-align-center font-size-sm-base text-color-white"
          v-html="loadingText"
          ></weex-text>
      </div>
    </div>
  </div>
</template>

<script>
  import WxcOverlay from "../../../weex-ui/packages/wxc-overlay/index";

  export default {
    components: { WxcOverlay },
    props: {

      loading: {
        type: Boolean,
        default: false
      },

      loadingText: {
        type: String,
        default: 'Please wait'
      }
    }
  };
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>

<style scoped>
  .ezcred-loading-container {
    position: absolute;
    z-index: 999999;
  }

  .progress-container {
    position: fixed;
    max-width: 450px;
    margin: auto;
    display: block;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .progress {
    width: 200px;
    background: #505050;
    padding: 20px 5px;
  }
</style>
